import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { activateTrial } from '../../actions/api';
import { ACTIVATE_TRIAL_SUCCESS, } from '../../constants/ActionTypes';
import ApiV2ModelContext from '../../contexts/ApiV2ModelContext';
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export const withHandleActivateTrial = (WrappedComponent) => {
    var _a;
    return connect(mapStateToProps, mapDispatchToProps)((_a = class HandleActivateTrial extends React.Component {
            constructor() {
                super(...arguments);
                this.handle = () => {
                    const { dispatch } = this.props;
                    dispatch(activateTrial()).then(async (action) => {
                        if (action.type === ACTIVATE_TRIAL_SUCCESS) {
                            try {
                                await this.context.getMe(dispatch);
                            }
                            catch (error) {
                                console.error(error);
                            }
                        }
                    });
                };
            }
            render() {
                const { user, ...rest } = this.props;
                const trialActivateable = !user.user || !user.user.plan || !user.user.plan.trialExpirationDate;
                return (_jsx(WrappedComponent, { ...rest, handleActivateTrial: this.handle, trialActivateable: trialActivateable }));
            }
        },
        _a.contextType = ApiV2ModelContext,
        _a));
};
